<div class="grid-x">
  <div class="cell large-12 medium-12 small-12 bold">
    <div class="section-header" [ngClass]="{ 'active' : step == activeStep }" (click)="toggleOpen()">
      <span class="margin-right">Step 4: Water Source for Production Operations</span>
      <button class="icon-button">
        @if (isOpen == false) {
          <svg-icon icon="icon-caret-right"></svg-icon>
        }
        @if (isOpen == true) {
          <svg-icon icon="icon-caret-down"></svg-icon>
        }
      </button>
    </div>
  </div>
</div>
<div class="grid-x margin-top"  [formGroup]="form" [ngClass]="{ 'hideSection': isOpen == false }">
  <div class="cell large-2 medium-2 small-6 bold padding-right text-align-right">
    Water Source<span [ngClass]="{ 'red': form?.get('source')?.invalid }">*</span>:
    @if (fieldHasNotes('waterSource|source') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'waterSource|source'" [notes]="getFilteredNotes('waterSource|source')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-2 medium-2 small-6">
    <input type="text" formControlName="source" />
  </div>
  <div class="cell large-2 medium-2 small-6 text-align-right padding-right bold">
    <help-text [helpText]="coordinateHelpText"></help-text><span class="padding-left">Latitude:</span>
    @if (fieldHasNotes('waterSource|latitude') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'waterSource|latitude'" [notes]="getFilteredNotes('waterSource|latitude')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-2 medium-2 small-6">
    <input type="number" formControlName="latitude" (ngModelChange)="coordinateChanged($event)" (blur)="roundCoordinate('latitude')" />
  </div>
  <div class="cell large-2 medium-2 small-6 text-align-right padding-right bold">
    <help-text [helpText]="coordinateHelpText"></help-text><span class="padding-left">Longitude:</span>
    @if (fieldHasNotes('waterSource|longitude') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'waterSource|longitude'" [notes]="getFilteredNotes('waterSource|longitude')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-2 medium-2 small-6">
    <input type="number" formControlName="longitude" (ngModelChange)="coordinateChanged($event)" (blur)="roundCoordinate('longitude')" />
  </div>
  @if (requireWatershedValidation) {
    <div class="cell large-1 medium-1 small-1 text-align-center">
      &nbsp;
    </div>
    <div class="cell large-10 medium-10 small-10 text-align-center">
      <button class="button full-width" [disabled]="requireWatershedValidation == false && !fieldHasNotes('waterSource|watershed')" (click)="validateWatershed()">Validate Watershed</button>
    </div>
    <div class="cell large-1 medium-1 small-1 text-align-center">
      @if (form?.get('watershedValidated')?.valid) {
        <svg-icon class="large green" icon="icon-checkbox"></svg-icon>
      }
      @if (form?.get('watershedValidated')?.invalid) {
        <svg-icon class="tiny red" icon="icon-alert"></svg-icon>
      }
    </div>
  }
  <div class="cell large-2 medium-2 small-6 text-align-right padding-right bold">
    Watershed@if (requireWatershedValidation == false) {
    <span [ngClass]="{ 'red': form?.get('watershed')?.invalid }">*</span>
    }@if (requireWatershedValidation) {
    <span><help-text [helpText]="validationRequiredHelpText" [alert]="form?.get('watershedValidated')?.invalid"></help-text></span>
    }:
    @if (fieldHasNotes('waterSource|watershed') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'waterSource|watershed'" [notes]="getFilteredNotes('waterSource|watershed')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-4 medium-4 small-4 text-align-center">
    <span class="padding-right">
      <input type="radio" formControlName="watershed" value="LAKEERIE" (ngModelChange)="watershedChanged($event)" /> Lake Erie
    </span>
    <span class="padding-right">
      <input type="radio" formControlName="watershed" value="OHIORIVER" (ngModelChange)="watershedChanged($event)" /> Ohio River
    </span>
    <span class="padding-right">
      <input type="radio" formControlName="watershed" value="OTHER" (ngModelChange)="watershedChanged($event)" /> Other <help-text [helpText]="watershedHelpText"></help-text>
    </span>
  </div>
  <div class="cell large-2 medium-2 small-6 text-align-right padding-right bold">
    Other@if (form?.get('watershed')?.value == 'OTHER') {
    <span [ngClass]="{ 'red': form?.get('watershedOther')?.invalid }">*</span>
    }:
    @if (fieldHasNotes('waterSource|watershedOther') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'waterSource|watershedOther'" [notes]="getFilteredNotes('waterSource|watershedOther')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-4 medium-4 small-6">
    <input type="text" formControlName="watershedOther" />
  </div>
  <div class="cell large-4 medium-4 small-6 text-align-right padding-right bold">
    Estimated Withdrawl Rate (gallons / day)<span [ngClass]="{ 'red': form?.get('withdrawalRate')?.invalid }">*</span>:
    @if (fieldHasNotes('waterSource|withdrawalRate') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'waterSource|withdrawalRate'" [notes]="getFilteredNotes('waterSource|withdrawalRate')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-2 medium-2 small-6">
    <input type="number" formControlName="withdrawalRate" />
  </div>
  <div class="cell large-4 medium-2 small-6 text-align-right padding-right bold">
    Estimated Total Volume (gallons)<span [ngClass]="{ 'red': form?.get('totalVolume')?.invalid }">*</span>:
    @if (fieldHasNotes('waterSource|totalVolume') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'waterSource|totalVolume'" [notes]="getFilteredNotes('waterSource|totalVolume')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-2 medium-2 small-6">
    <input type="number" formControlName="totalVolume" />
  </div>
  <div class="cell large-6 medium-6 small-6 text-align-right padding-right bold">
    If Recycled Water, Estimated Total Volume (gallons)<span [ngClass]="{ 'red': form?.get('recycledWater')?.invalid }">*</span>:
    @if (fieldHasNotes('waterSource|recycledWater') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'waterSource|recycledWater'" [notes]="getFilteredNotes('waterSource|recycledWater')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-2 medium-2 small-6">
    <input type="number" formControlName="recycledWater" />
  </div>
</div>